export type CheckIn = {
  name: string;
  datetime: string;
  type: CheckInType;
  location: string;
  calendar?: string | undefined;
}

export enum CheckInType {
  Zoom,
  InPerson,
  GoogleMeet,
  Skype,
  Phone,
  Online
}

export const checkinTypeFromString = (s : string) => {
  switch(s) {
    case 'Zoom':
      return CheckInType.Zoom;
    case 'InPerson':
      return CheckInType.InPerson;
    case 'GoogleMeet':
      return CheckInType.GoogleMeet;
    case 'Skype':
      return CheckInType.Skype;
    case 'Phone':
      return CheckInType.Phone;
    case 'Online':
      return CheckInType.Online;
    default:
      return CheckInType.Zoom;
  }
}